import { render, staticRenderFns } from "./IndexExternal.vue?vue&type=template&id=0c62b666&scoped=true&"
import script from "./IndexExternal.vue?vue&type=script&lang=js&"
export * from "./IndexExternal.vue?vue&type=script&lang=js&"
import style0 from "./IndexExternal.vue?vue&type=style&index=0&id=0c62b666&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c62b666",
  null
  
)

export default component.exports